import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirEncounters } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirEncounters.STARTED]: handleActionStart,
  [fetchFhirEncounters.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirEncounters.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.encounters,
  [clearCurrentPatient]: () => initialState,
});
